import { Button, Form, Modal } from "antd"
import { type Store } from "antd/lib/form/interface"
import React, { type ComponentType } from "react"
import { useTranslation } from "react-i18next"
import { type FilterFormProps } from "~Components/filter/filterTypes"

interface FilterModalProps<FilterValuesType extends Store> {
    FilterForm: ComponentType<FilterFormProps<FilterValuesType>>
    isVisible: boolean
    hideFilterModal: () => void
    onFilter: (values: FilterValuesType) => void
    filters: FilterValuesType
}

export const FilterModal = <FilterValuesType extends Store>({ FilterForm, isVisible, hideFilterModal, filters, onFilter }: FilterModalProps<FilterValuesType>) => {
    const { t } = useTranslation()
    const [formInstance] = Form.useForm()

    return (
        <Modal
            title={t("action:filter")}
            open={isVisible}
            maskClosable={false}
            onOk={formInstance.submit}
            onCancel={hideFilterModal}
            keyboard
            destroyOnClose
            footer={[
                <Button
                    key="back"
                    onClick={() => {
                        formInstance.resetFields()
                        hideFilterModal()
                    }}
                >
                    {t("action:cancel")}
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                        formInstance.submit()
                    }}
                >
                    {t("action:apply_filter")}
                </Button>,
            ]}
        >
            <FilterForm formInstance={formInstance} filters={filters} onFilter={onFilter} />
        </Modal>
    )
}
